<template>
  <v-container class="pa-0">
    <v-row>
      <v-col cols="12" lg="12">
        <div class="d-flex justify-space-between" style="background-color: #F2F2F2; border-radius: 4px; height: 60px; align-items: center; padding: 0 10px;">
          <v-btn text @click="reloadAll" class="px-0"
            ><v-icon color="#F15A24">mdi-refresh</v-icon> Atualizar Feed</v-btn
          >
        </div>
        <v-row>
          <v-col v-if="anotacoes.length == 0 && !loadingFeed" cols="12">
            <p class="mt-5">
              Ainda não existe conteúdo por aqui. Faça anotações e conexões para
              alimentar o seu feed.
            </p>
          </v-col>
          <v-col v-if="loadingFeed" cols="12" class="text-center">
            <v-progress-circular class="mx-auto" color="#F15A24" indeterminate></v-progress-circular>
          </v-col>
          <v-col v-for="(annotation, i) in anotacoes" :key="i" cols="12">
            <annotation :annotation="annotation"></annotation>
          </v-col>


        </v-row>
      </v-col>

     
    </v-row>
    <!-- Snackbar para mobile, Dialog para desktop -->
    <v-snackbar
      v-if="intBreakPoint <= 1"
      v-model="confirm"
      :timeout="4000"
      top
      color="#f15a24"
      :multi-line="mensagemConfirm && mensagemConfirm.length > 40"
      style="z-index: 9999;"
    >
      <div class="d-flex align-center" style="flex: 1;">
        <v-icon color="white" class="mr-2" size="24">mdi-account-check</v-icon>
        <span style="color: white; font-weight: 500; font-size: 14px;">{{ mensagemConfirm }}</span>
      </div>
      <template v-slot:action="{ attrs }">
        <v-btn
          text
          v-bind="attrs"
          @click="confirm = false"
          color="white"
          small
        >
          Fechar
        </v-btn>
      </template>
    </v-snackbar>
    
    <!-- Dialog para desktop -->
    <v-dialog 
      v-if="intBreakPoint > 1"
      v-model="confirm" 
      max-width="400px"
      persistent
    >
      <v-card
        style="
          min-height: 120px;
          overflow-x: hidden;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 20px;
        "
      >
        <v-row>
          <v-col cols="12" class="text-center">
            <v-icon size="48" color="#f15a24" class="mb-3">mdi-account-check</v-icon>
            <h2 style="text-align: center; color: #f15a24; font-size: 18px; word-wrap: break-word;">
              {{ mensagemConfirm }}
            </h2>
            <v-btn
              color="#F15A24"
              dark
              class="mt-4"
              @click="confirm = false"
              block
            >
              OK
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<style scoped>
.stickyCol {
  position: sticky;
  position: -webkit-sticky;
  top: 20px;
  align-items: start;
  display: inline-block;
}

.colDica {
  background-color: #f5f3f2;
}

.colDica:hover,
.colNoticia:hover,
.colArtigo:hover {
  background-color: #dfdbd6;
}

.annotation {
  border: 1px solid rgb(200 200 200) !important;
  margin: 8px 0px;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.annotationText div {
  width: 100%;
}

.secondRow h3 {
  margin: 30px 0px 0px 15px;
}

.annotation ::v-deep img,
.comentario ::v-deep img {
  max-width: 100% !important;
}
.annotation ::v-deep h1 {
  line-height: 1.2 !important;
}
.secondRow p {
  padding: 10px 15px;
  background-color: #472f8c;
  color: white;
  width: 100%;
}

a {
  text-decoration: none;
  color: black;
}

a:hover {
  text-decoration: underline;
  color: #f15a24;
}

.colDica a {
  color: black;
}

.colNoticia a:hover {
  text-decoration-color: black;
}

.reg {
  border: 1px dashed gray;
  border-radius: 10px;
  padding: 10px;
  background-color: #f8f9fa;
  font-style: italic;
}

/* Estilos para o conteúdo HTML renderizado */
.annotationText ::v-deep h1,
.annotationText ::v-deep h2,
.annotationText ::v-deep h3,
.annotationText ::v-deep h4,
.annotationText ::v-deep h5,
.annotationText ::v-deep h6 {
  margin: 0.5rem 0;
  font-weight: 600;
  color: #333;
  line-height: 1.4;
}

.annotationText ::v-deep h3 {
  font-size: 1.25rem;
  font-weight: 600;
  color: #333;
  line-height: 1.4;
}

.annotationText ::v-deep p {
  margin: 0.5rem 0;
  line-height: 1.6;
  color: #333;
}

.annotationText ::v-deep strong,
.annotationText ::v-deep b {
  font-weight: 600;
  color: #333;
}

.annotationText ::v-deep a {
  color: #F15A24;
  text-decoration: underline;
}

.annotationText ::v-deep a:hover {
  color: #d14a1a;
  text-decoration: underline;
}

.annotationText ::v-deep ul,
.annotationText ::v-deep ol {
  margin: 0.5rem 0;
  padding-left: 1.5rem;
}

.annotationText ::v-deep li {
  margin: 0.25rem 0;
  line-height: 1.5;
}

.anno a {
  color: #F15A24 !important;
  text-decoration: none;
  padding: 0
}

a:hover {
  text-decoration: underline;
}

.v-btn {
  text-transform: none;
  font-weight: 500;
}

.v-card-title {
  font-size: 1rem;
  font-weight: 500;
}

.v-card-text h3 {
  font-size: 1.25rem;
  font-weight: 600;
  color: #333;
  line-height: 1.4;
}

.text-caption {
  font-size: 0.75rem;
}

.grey--text {
  color: #666 !important;
}

/* Estilos para o cabeçalho dos posts */
.user-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.user-name {
  font-size: 14px;
  font-weight: 600;
  color: #333;
  line-height: 1.2;
}

.law-reference {
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #666;
}

.law-link {
  color: #000 !important;
  text-decoration: underline;
  font-weight: 500;
}

.law-link:hover {
  color: #F15A24 !important;
  text-decoration: underline;
}

.text-caption {
  font-size: 12px;
  color: #666;
}

/* Mobile specific styles */
@media (max-width: 600px) {
  .law-reference{
    display: block;
  }

  .v-card__actions {
    padding: 12px !important;
  }
  
  .v-card__actions .v-btn {
    min-width: auto !important;
    padding: 0 8px !important;
  }
  
  .v-card__actions .v-btn .v-icon {
    margin-right: 4px !important;
  }
}

/* Tablet styles */
@media (min-width: 601px) and (max-width: 960px) {
  .v-card__actions {
    padding: 16px !important;
  }
}

</style>

<script>
// import AvatarDpo from '../components/AvatarDpo.vue';
import Annotation from "../components/Annotation.vue";
export default {
  name: "HomeFeed",
  components: { Annotation },
  data() {
    return {
      confirm: false,
      comment: "",
      profileDetails: null,
      importPost: { id_lei: {}, id_reg: {} },
      mensagemConfirm: "",
      showNewAnnotation: false,
      loadingNewAnnotation: false,
      searchText: "",
      commentText: "",
      suggestFriends: [],
      searchTimeout: null,
      anotacoes: [],
      offset: 0,
      limit: 10,
      publicFeed: {
        anotacoes: [],
        hasMore: true,
      },
      friendsFeed: {
        anotacoes: [],
        hasMore: true,
      },
      groupsFeed: {
        anotacoes: [],
        hasMore: true,
      },
      loadingFeed: false,
      statusAnnotation: [
        { text: "Público", value: "published" },
        { text: "Grupo", value: "group" },
        { text: "Privado", value: "private" },
        { text: "Apenas Amigos", value: "friend" },
        { text: "Arquivado", value: "archived" },
      ],
      customToolbar: [
        [{ font: [] }, { size: [] }],
        ["bold", "italic", "underline", "strike"],
        [{ color: [] }, { background: [] }],
        // [{ script: "super" }, { script: "sub" }],
        [{ header: "1" }, { header: "2" }, "blockquote", "code-block"],

        [
          { list: "ordered" },
          { list: "bullet" },
          { indent: "-1" },
          { indent: "+1" },
        ],
        ["direction", { align: [] }],
        ["link", "image", "video"],
        ["clean"],
      ],
      customToolbar1: [
        [{ font: [] }, { size: [] }],
        ["bold", "italic", "underline", "strike"],
        [{ color: [] }, { background: [] }],
        // [{ script: "super" }, { script: "sub" }],
        [{ header: "1" }, { header: "2" }, "blockquote"],
        [
          { list: "ordered" },
          { list: "bullet" },
          { indent: "-1" },
          { indent: "+1" },
        ],
        ["direction", { align: [] }],
        ["link", "image", "video"],
        ["clean"],
      ],
    };
  },
  async mounted() {
    window.addEventListener("scroll", this.handleScroll);
    if (this.user !== undefined) {
      this.$store.dispatch("realoadVadeMecuns");
      this.anotacoes = [];
      this.offset = 0;
      this.loadFeed();
    }
  },
  beforeDestroy() {
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }
    window.removeEventListener("scroll", this.handleScroll);
  },
  watch: {
  },
  methods: {
    async reloadAll() {
      this.anotacoes = [];
      this.offset = 0;
      this.loadFeed();
    },
    handleScroll() {
      const bottomOfWindow =
        window.innerHeight + window.scrollY >= document.body.offsetHeight - 100;
      if (bottomOfWindow) {
        this.loadFeed();
      }
    },
    updateFeed(feed, newEntries) {
      const uniqueEntries = new Map(
        [...feed.anotacoes, ...newEntries].map((anotacao) => [
          anotacao.id,
          anotacao,
        ])
      );
      feed.anotacoes = Array.from(uniqueEntries.values());
    },
    async fetchAnnotations(query, variables = {}) {
      const response = await this.$http.post("/graphql", {
        query,
        variables,
      });

      const anotacoes = response.data.data.anotacoes || [];

      const shuffleArray = (array) => {
        for (let i = array.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [array[i], array[j]] = [array[j], array[i]];
        }
        return array;
      };

      return shuffleArray([...anotacoes]);
    },
    async loadPublicFeed() {
      if (!this.publicFeed.hasMore) return [];
      const query = `
		    query PublicAnnotations($offset: Int, $limit: Int) {
		      anotacoes(
		        filter: { status: { _eq: "published" } },
		        sort: ["-date_created"],
		        offset: $offset,
		        limit: $limit
		      ) {
		        id
		        texto
		        date_created
		        date_updated
		        status
		        likes { id first_name }
		        comentarios(filter: { status: { _eq: "published" } }) {
		          id
		          message
		          files {
		            id
		            directus_files_id { id filename_download }
		          }
		          user_created { id first_name avatar { id } }
		        }
		        user_created {
		          first_name
		          last_name
		          id
		          avatar { id }
		        }
		        id_lei { id_lei numero_lei }
		        id_reg { id_reg conteudo }
		      }
		    }
		  `;
      return this.fetchAnnotations(query, {
        offset: this.offset,
        limit: this.limit,
      });
    },

    async loadFriendsFeed() {
      if (!this.friendsFeed.hasMore) return [];
      const query = `
		    query FriendsAnnotations($userId: String, $offset: Int, $limit: Int) {
		      anotacoes(
		        filter: {
		          _and: [
		            { status: { _eq: "friend" } },
		            {
		              user_created: {
		                amigos: { id_amigo: { id: { _eq: $userId } } }
		              }
		            }
		          ]
		        },
		        sort: ["-date_created"],
		        offset: $offset,
		        limit: $limit
		      ) {
		        id
		        texto
		        date_created
		        date_updated
		        status
				likes { id first_name }
		        comentarios(filter: { status: { _eq: "published" } }) {
		          id
		          message
		          files {
		            id
		            directus_files_id { id filename_download }
		          }
		          user_created { id first_name avatar { id } }
		        }
		        user_created {
		          first_name
		          last_name
		          id
		          avatar { id }
		        }
				id_lei { id_lei numero_lei }
		        id_reg { id_reg conteudo }
		      }
		    }
		  `;
      return this.fetchAnnotations(query, {
        userId: this.user.id,
        offset: this.offset,
        limit: this.limit,
      });
    },

    async loadGroupsFeed() {
      if (!this.groupsFeed.hasMore) return [];
      const query = `
		    query GroupsAnnotations($userId: String, $offset: Int, $limit: Int) {
		      anotacoes(
		        filter: {
		          _and: [
		            { status: { _eq: "group" } },
		            {
		              id_grupo: {
		                integrantes: {
		                  directus_users_id: { id: { _eq: $userId } }
		                }
		              }
		            }
		          ]
		        },
		        sort: ["-date_created"],
		        offset: $offset,
		        limit: $limit
		      ) {
		        id
		        texto
		        date_created
		        date_updated
		        status
				likes { id first_name }
		        comentarios(filter: { status: { _eq: "published" } }) {
		          id
		          message
		          files {
		            id
		            directus_files_id { id filename_download }
		          }
		          user_created { id first_name avatar { id } }
		        }
		        user_created {
		          first_name
		          last_name
		          id
		          avatar { id }
		        }
				id_lei { id_lei numero_lei }
		        id_reg { id_reg conteudo }
		        id_grupo { id nome_grupo }
		      }
		    }
		  `;
      return this.fetchAnnotations(query, {
        userId: this.user.id,
        offset: this.offset,
        limit: this.limit,
      });
    },

    async loadFeed() {
      if (this.loadingFeed) return;
      this.loadingFeed = true;

      try {
        const [publicAnnotations, friendsAnnotations, groupsAnnotations] =
          await Promise.all([
            this.loadPublicFeed(),
            this.loadFriendsFeed(),
            this.loadGroupsFeed(),
          ]);

        this.updateFeed(this.publicFeed, publicAnnotations);
        this.updateFeed(this.friendsFeed, friendsAnnotations);
        this.updateFeed(this.groupsFeed, groupsAnnotations);

        this.publicFeed.hasMore = publicAnnotations.length >= this.limit;
        this.friendsFeed.hasMore = friendsAnnotations.length >= this.limit;
        this.groupsFeed.hasMore = groupsAnnotations.length >= this.limit;

        this.offset += this.limit;

        const uniqueAnotacoes = new Map(
          [
            ...this.anotacoes,
            ...publicAnnotations,
            ...friendsAnnotations,
            ...groupsAnnotations,
          ].map((anotacao) => [anotacao.id, anotacao])
        );
        this.anotacoes = Array.from(uniqueAnotacoes.values());
      } catch (error) {
        window.console.error("Erro ao carregar feed:", error);
      } finally {
        this.loadingFeed = false;
      }
    },

    async loadSuggestFriends() {
      let suggestIds = [
        "2112b577-7c91-47c7-82c5-080a2a3f555c",
        "9ec0bfad-f4fe-4f7f-8686-b0cd5a86c274",
        "f98bc34a-e46b-4392-9a68-8bc76a1694a5",
        "f50cf686-94f2-432a-a7a7-5fa2c70a5b7d",
        "7da54d20-e456-4dda-b50a-912cf0de106f",
        "a0c26080-6199-48d5-b94d-90cd527af285",
      ];
      const { data } = await this.$http.get(
        `users/?fields=id,first_name,avatar,last_name
			             &filter[id][_in]=${suggestIds}`
      );
      this.suggestFriends = data.data;
      // window.console.log(this.friends)
    },
    handleImageAdded(file, Editor, cursorLocation) {
      // window.console.log(file);
      const formData = new FormData();
      formData.append("image", file);
      this.$http
        .post("/files", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          // window.console.log(response);
          let url = `https://api.mylegis.com.br/assets/${response.data.data.id}`;
          Editor.insertEmbed(cursorLocation, "image", url);
        })
        .catch(() => {
          // window.console.log(err);
        });
    },
    saveNewAnnotation() {
      this.loadingNewAnnotation = true;
      let dt = {
        id_lei: this.importPost.id_lei,
        id_reg: this.importPost.id_reg,
        status: this.importPost.status,
        id_grupo:
          this.importPost.status == `group` ? this.importPost.id_grupo : null,
        texto: this.importPost.texto,
      };
      this.$http
        .post("items/anotacoes", dt)
        .then((response) => {
          if (response.data.data.id != undefined) {
            this.loadingNewAnnotation = false;
            this.showNewAnnotation = false;
            // this.importPost = { status: "private" };
            (this.importPost = { id_lei: {}, id_reg: {} }),
              (this.conteudoSelected = {});

            let conteudo = this.conteudos.find((el) => el.id_reg === dt.id_reg);
            if (conteudo.anotacoes) conteudo.anotacoes.push(response.data.data);
            else conteudo.anotacoes = [response.data.data];
          }
        })
        .catch(() => {
          this.loadingNewAnnotation = false;
        });
    },
    sanitizeTitle: function (title) {
      var slug = "";
      // Change to lower case
      var titleLower = title.toLowerCase();
      // Letter "e"
      slug = titleLower.replace(/e|é|è|ẽ|ẻ|ẹ|ê|ế|ề|ễ|ể|ệ/gi, "e");
      // Letter "a"
      slug = slug.replace(/a|á|à|ã|ả|ạ|ă|ắ|ằ|ẵ|ẳ|ặ|â|ấ|ầ|ẫ|ẩ|ậ/gi, "a");
      // Letter "o"
      slug = slug.replace(/o|ó|ò|õ|ỏ|ọ|ô|ố|ồ|ỗ|ổ|ộ|ơ|ớ|ờ|ỡ|ở|ợ/gi, "o");
      // Letter "u"
      slug = slug.replace(/u|ú|ù|ũ|ủ|ụ|ư|ứ|ừ|ữ|ử|ự/gi, "u");
      // Letter "d"
      slug = slug.replace(/đ/gi, "d");
      // Trim the last whitespace
      slug = slug.replace(/\s*$/g, "");
      // Change whitespace to "-"
      slug = slug.replace(/\s+/g, "-");

      return slug;
    },
  },
  filters: {
    filterStatus(v) {
      switch (v) {
        case "published":
          return "Público";
        case "friend":
          return "Amigos";
        case "group":
          return "Grupo";
        case "private":
          return "Privado";
      }
    },
  },
  computed: {
    groups() {
      return this.$store.state.user.grupos;
    },
    user() {
      return this.$store.state.user;
    },
    intBreakPoint() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 0;
        case "sm":
          return 1;
        case "md":
          return 2;
        case "lg":
          return 3;
        case "xl":
          return 4;
        default:
          return 0;
      }
    },
  },
};
</script>
